import { Region } from 'constants/shop';
import { resolveHandles } from './collections/utils/resolve-handles';
import { CommonPagePaths } from './types';

// Localized paths of the pages served by `/pages/[handle]`, ready to be used as href.
// Switzerland is not listed — it falls back to the German paths.
const COMMON_PAGE_PATHS = {
  aboutUs: { [Region.DE]: '/pages/uber-uns', [Region.NL]: '/pages/over-ons' },
  catsHome: { [Region.DE]: '/pages/katzen', [Region.NL]: '/pages/katten' },
  coronaFaq: { [Region.DE]: '/pages/informationen-zu-corona' },
  dataProtection: { [Region.DE]: '/pages/datenschutz', [Region.NL]: '/pages/privacybeleid' },
  dogsHome: { [Region.DE]: '/pages/hunde', [Region.NL]: '/pages/honden' },
  foodAward: {
    [Region.DE]: '/pages/futtertester-nassfutter-fur-hunde',
    [Region.NL]: '/pages/voedseltester-natvoer-voor-honden',
  },
  foodConsultation: {
    [Region.DE]: '/pages/unsere-futterberatung-online-und-telefonisch',
    [Region.NL]: '/pages/ons-voedingsadvies-online-en-telefonisch',
  },
  foodFinder: { [Region.DE]: '/pages/futterfinder' },
  foodTypesCats: {
    [Region.DE]: '/pages/die-verschiedenen-futterungsarten-fur-katzen',
    [Region.NL]: '/pages/de-verschillende-voedingswijzen-voor-katten',
  },
  foodTypesDogs: {
    [Region.DE]: '/pages/die-verschiedenen-futterungsarten-fur-hunde',
    [Region.NL]: '/pages/de-verschillende-voedingswijzen-voor-honden',
  },
  referFriend: { [Region.DE]: '/pages/freund-geworben', [Region.NL]: '/pages/vriend-geworven' },
  savingsSubscription: {
    [Region.DE]: '/pages/unser-spar-abo',
    [Region.NL]: '/pages/ons-voordeelabonnement',
  },
  storeFinder: {
    [Region.DE]: '/pages/haendlersuche',
    [Region.NL]: '/pages/pets-deli-in-de-winkel',
  },
  subscription: {
    [Region.DE]: '/pages/regelmassige-lieferung',
    [Region.NL]: '/pages/ons-voordeelabonnement',
  },
  termsAndConditions: {
    [Region.DE]: '/pages/agb-und-widerruf',
    [Region.NL]: '/pages/algemene-voorwaarden',
  },
} as const satisfies Record<keyof CommonPagePaths, Partial<Record<Region, string>>>;

// Flattened once per region — the shape exposed on the shop config as `commonPagePaths`.
export const COMMON_PAGE_PATHS_BY_REGION: Record<Region, CommonPagePaths> = {
  [Region.DE]: resolveHandles(COMMON_PAGE_PATHS, Region.DE),
  [Region.CH]: resolveHandles(COMMON_PAGE_PATHS, Region.CH),
  [Region.NL]: resolveHandles(COMMON_PAGE_PATHS, Region.NL),
};
